import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 500 500"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M250 0c138.076 0 250 111.924 250 250S388.076 500 250 500 0 388.076 0 250 111.924 0 250 0m86.239 351.902c4.598-14.109 26.141-154.717 28.804-182.424.805-8.391-1.847-13.967-7.043-16.456-6.283-3.022-15.587-1.511-26.381 2.38-14.804 5.337-204.065 85.696-215 90.348-10.369 4.402-20.173 9.206-20.173 16.163 0 4.891 2.902 7.641 10.902 10.5 8.326 2.967 29.293 9.326 41.674 12.739 11.924 3.294 25.5.435 33.108-4.293 8.066-5.011 101.142-67.294 107.826-72.75 6.674-5.457 12 1.532 6.544 7-5.457 5.456-69.348 67.467-77.772 76.054-10.228 10.424-2.967 21.228 3.891 25.554 7.837 4.935 64.196 42.739 72.685 48.805 8.489 6.065 17.098 8.815 24.979 8.815 7.88 0 12.032-10.381 15.956-22.435" }, null, -1)
  ])))
}
export default { render: render }